/**
 * Next's DefinePlugin replaces `process.env.NEXT_DEPLOYMENT_ID` with the boolean literal `false`
 * when no deployment id is configured, despite TypeScript typing it as `string | undefined`.
 * Accepting `unknown` keeps that mismatch from leaking into callers.
 */
export function parseDeploymentId(inlinedValue: unknown): string | null {
    if (typeof inlinedValue !== 'string') {
        return null;
    }
    const trimmed = inlinedValue.trim();
    return trimmed.length > 0 ? trimmed : null;
}
